import { Component, Input } from '@angular/core';

import { Relay } from '@app/core/models/relay';

@Component({
  selector: 'app-traffic-light[relay]',
  templateUrl: './traffic-light.component.html',
  styleUrls: ['./traffic-light.component.scss']
})
export class TrafficLightComponent {
  @Input() relay!: Relay;
  constructor(
  ) { }
}
